import { render, staticRenderFns } from "./TerminRaumUpdateModal.vue?vue&type=template&id=22f4e4d8&"
import script from "./TerminRaumUpdateModal.vue?vue&type=script&lang=js&"
export * from "./TerminRaumUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports